import { render, staticRenderFns } from "./WillResidentialChildrenAfterYN.vue?vue&type=template&id=04bb2f13"
import script from "./WillResidentialChildrenAfterYN.vue?vue&type=script&lang=js"
export * from "./WillResidentialChildrenAfterYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports